import { useState, useEffect, useRef, useCallback } from "react";
import Hero1 from "../assets/images/pictures/Hero_1.png";
import Hero1E from "../assets/images/pictures/Hero_1_English.png";
import Hero2 from "../assets/images/pictures/Hero_2.png";
import Hero2E from "../assets/images/pictures/Hero_2_English.png";
import Hero3 from "../assets/images/pictures/Hero_3.png";
import Hero3E from "../assets/images/pictures/Hero_3_English.png";
import Hero4 from "../assets/images/pictures/Hero_4.png";
import Hero4E from "../assets/images/pictures/Hero_4_English.png";
import Logo from "../assets/images/logos/lgoo.png";
import vn8 from "../assets/images/flag/vn8.png";
import en8 from "../assets/images/flag/eng8.png";
import { useSelector } from "react-redux";
import { selectLanguage } from "./../redux/language/selector";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MoonLoader } from "react-spinners";

/* ─── DATA ─── */

/* ─── STYLES ─── */
const GLOBAL_CSS = `
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,400&display=swap');

:root {
  --primary: #0B3C5D;
  --primary-dark: #072a42;
  --primary-light: #1a5276;
  --accent: #239CBA;
  --accent-light: #3bbdd6;
  --accent-glow: rgba(35,156,186,0.25);
  --white: #ffffff;
  --light: #f4f8fb;
  --gray: #e8eef4;
  --gray-mid: #b0bec5;
  --text: #1a2b38;
  --text-muted: #5a7a8a;
  --success: #27ae60;
  --border: rgba(11,60,93,0.12);
}
     /* ── PHONE SHAKE ANIMATION ── */
    @keyframes phoneShake {
      0% {
        transform: rotate(0deg);
      }

      /* Tăng biên độ lên gấp rưỡi hoặc gấp đôi ở các nhịp đầu */
      8% {
        transform: rotate(-25deg);
      }

      16% {
        transform: rotate(25deg);
      }

      24% {
        transform: rotate(-20deg);
      }

      32% {
        transform: rotate(20deg);
      }

      /* Giảm dần biên độ để tạo hiệu ứng rung tự nhiên */
      40% {
        transform: rotate(-15deg);
      }

      48% {
        transform: rotate(15deg);
      }

      56% {
        transform: rotate(-10deg);
      }

      64% {
        transform: rotate(10deg);
      }

      72% {
        transform: rotate(-5deg);
      }

      80% {
        transform: rotate(5deg);
      }

      /* Kết thúc nhẹ nhàng */
      88% {
        transform: rotate(-2deg);
      }

      96% {
        transform: rotate(2deg);
      }

      100% {
        transform: rotate(0deg);
      }
    }
      a:focus, a:focus-visible {
  outline: none;
}
  .spinner-loading {
  position: fixed;        
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5); 
  z-index: 99999;        
  display: flex;
  align-items: center;
  justify-content: center;
}
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
html{scroll-behavior:smooth;font-size:16px;margin:0;padding:0;overflow-x:hidden;}
body{font-family:'Montserrat',sans-serif;color:var(--text);background:var(--white);overflow-x:hidden;line-height:1.6;margin:0;padding:0;width:100%;}
#hero{margin-top:0;padding-top:0;}
.gp-container{max-width:1200px;margin:0 auto;padding:0 24px;}
.section-pad{padding:100px 0;}
.section-pad-sm{padding:70px 0;}
.tag{display:inline-block;font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:var(--accent);background:rgba(35,156,186,0.1);border:1px solid rgba(35,156,186,0.25);padding:5px 14px;border-radius:20px;margin-bottom:18px;}
.section-title{font-size:clamp(28px,4vw,44px);font-weight:800;color:var(--primary);line-height:1.2;margin-bottom:16px;}
.section-sub{font-size:17px;color:var(--text-muted);max-width:820px;font-weight:400;line-height:1.7;}
.btn-landing{display:inline-flex;align-items:center;gap:9px;padding:14px 32px;border-radius:50px;font-family:'Montserrat',sans-serif;font-weight:700;font-size:14px;letter-spacing:0.5px;text-decoration:none;cursor:pointer;border:none;transition:all 0.28s cubic-bezier(0.4,0,0.2,1);white-space:nowrap;}
.btn-landing-primary-landing{background:linear-gradient(135deg,var(--accent) 0%,#1a7fa0 100%);color:var(--white);box-shadow:0 6px 28px rgba(35,156,186,0.4);}
.btn-landing-primary-landing:hover{transform:translateY(-2px);box-shadow:0 12px 36px rgba(35,156,186,0.55);}
.btn-landing-outline{background:transparent;color:var(--white);border:2px solid rgba(255,255,255,0.6);}
.btn-landing-outline:hover{background: rgba(255, 255, 255, 0.1);border: 2px solid rgba(255, 255, 255, 0.6);}
.btn-phone-shake:hover .fa-phone{animation: phoneShake 1s infinite; transform-origin: center; display: inline-block;}
.btn-landing-dark{background:var(--primary);color:var(--white);box-shadow:0 6px 24px rgba(11,60,93,0.35);}
.btn-landing-dark:hover{background:var(--primary-light);transform:translateY(-2px);color:var(--white);text-decoration:none;}
@keyframes fadeUp{from{opacity:0;transform:translateY(30px);}to{opacity:1;transform:translateY(0);}}
.fade-up{opacity:0;animation:fadeUp 0.7s ease forwards;}
.delay-1{animation-delay:0.1s;}.delay-2{animation-delay:0.2s;}.delay-3{animation-delay:0.3s;}.delay-4{animation-delay:0.4s;}.delay-5{animation-delay:0.5s;}
/* REVEAL */
.reveal{opacity:0;transform:translateY(24px);transition:opacity 0.6s ease,transform 0.6s ease;}
.reveal.visible{opacity:1;transform:translateY(0);}
/* LANG */
.lang-select-wrap{position:relative;display:flex;align-items:center;}
.lang-select{appearance:none;-webkit-appearance:none;background:rgba(255,255,255,0.1);border:1px solid rgba(255,255,255,0.25);color:rgba(255,255,255,0.9);font-family:'Montserrat',sans-serif;font-size:12px;font-weight:600;padding:0 30px 0 14px;height:39px;border-radius:50px;cursor:pointer;transition:all 0.25s;outline:none;letter-spacing:0.3px;min-width:130px;}
.lang-select:hover,.lang-select:focus{background:rgba(255,255,255,0.18);border-color:var(--accent);color:#fff;}
.lang-select option{background:#0B3C5D;color:#fff;font-size:13px;}
.lang-chevron{position:absolute;right:11px;pointer-events:none;font-size:9px;color:rgba(255,255,255,0.6);}

/* LANG DROPDOWN (desktop, next to Demo button) */
.lang-dd-wrap{position:relative;}
.lang-dd-toggle{display:flex;align-items:center;gap:7px;background:rgba(255,255,255,0.08);border:1px solid rgba(255,255,255,0.28);border-radius:50px;padding:8px 12px;cursor:pointer;transition:all .25s;outline:none;}
.lang-dd-toggle:hover,.lang-dd-toggle:focus{background:rgba(255,255,255,0.18);border-color:var(--accent);}
.lang-dd-toggle img{width:20px;height:14px;object-fit:cover;border-radius:2px;display:block;}
.lang-dd-toggle .lang-dd-icon{font-size:10px;color:rgba(255,255,255,0.8);transition:transform .25s;}
.lang-dd-toggle .lang-dd-icon.open{transform:rotate(180deg);}
.lang-dd-menu{position:absolute;top:calc(100% + 10px);left:50%;transform:translateX(-50%);background:#fff;border-radius:12px;box-shadow:0 14px 34px rgba(0,0,0,0.2);min-width:172px;padding:6px;list-style:none;z-index:1100;}
.lang-dd-menu li{margin:0;}
.lang-dd-menu li button{display:flex;align-items:center;gap:10px;width:100%;padding:9px 12px;background:none;border:none;border-radius:8px;cursor:pointer;font-family:'Montserrat',sans-serif;font-size:13px;font-weight:600;color:var(--text);transition:background .15s;text-align:left;}
.lang-dd-menu li button:hover{background:var(--light);}
.lang-dd-menu li button.active{color:var(--accent);}
.lang-dd-menu li button img{width:20px;height:14px;object-fit:cover;border-radius:2px;}
/* LANG OPTIONS (mobile menu, 2 rõ ràng dưới nút Demo) */
.mobile-lang-switch{display:flex;gap:12px;margin-top:22px;}
.mobile-lang-option{display:flex;align-items:center;gap:8px;padding:10px 20px;border-radius:50px;border:1px solid rgba(255,255,255,0.3);background:rgba(255,255,255,0.06);color:#fff;font-family:'Montserrat',sans-serif;font-weight:600;font-size:13px;cursor:pointer;transition:all .2s;}
.mobile-lang-option img{width:20px;height:14px;object-fit:cover;border-radius:2px;}
.mobile-lang-option.active{background:var(--accent);border-color:var(--accent);}

/* NAVBAR */
#navbar{position:fixed;top:0;left:0;right:0;width:100%;z-index:1000;transition:all 0.35s ease;background:transparent;box-sizing:border-box;}
#navbar.scrolled{background:rgba(7,42,66,0.97);backdrop-filter:blur(12px);box-shadow:0 2px 24px rgba(0,0,0,0.25);}
.nav-inner{max-width:1200px;margin:0 auto;padding:0 24px;display:flex;align-items:center;justify-content:space-between;height:72px;}
.nav-logo{display:flex;align-items:center;gap:10px;text-decoration:none;}
.nav-logo-text{font-size:20px;font-weight:800;color:var(--white);letter-spacing:-0.5px;}
.nav-logo-text span{color:var(--accent);}
.nav-links{display:flex;align-items:center;gap:32px;list-style:none;}
.nav-links a{font-size:13px;font-weight:600;color:rgba(255,255,255,0.8);text-decoration:none;transition:color 0.2s;letter-spacing:0.3px;}
.nav-links a:hover{color:var(--accent-light);}
.nav-cta{display:flex;align-items:center;gap:12px;}
.hamburger{display:none;flex-direction:column;gap:5px;background:none;border:none;cursor:pointer;padding:4px;z-index:1001;position:relative;}
.hamburger span{display:block;width:24px;height:2px;background:white;border-radius:2px;transition:all 0.3s;}
/* Mobile overlay menu */
.mobile-menu-overlay{
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  position:fixed;
  inset:0;
  background:rgba(7,42,66,0.97);
  backdrop-filter:blur(12px);
  z-index:2000;
}
.mobile-menu-overlay ul{list-style:none;text-align:center;padding:0;}
.mobile-menu-overlay ul li{margin:16px 0;}
.mobile-menu-overlay ul li a{font-size:20px;font-weight:700;color:#fff;text-decoration:none;letter-spacing:0.5px;}
.mobile-menu-close{position:absolute;top:24px;right:24px;background:none;border:none;color:#fff;font-size:32px;cursor:pointer;line-height:1;}
.mobile-cta{margin-top:32px;}
/* HERO SLIDER */
.hero-slider{position:relative;width:100%;height:100vh;min-height:600px;overflow:hidden;}
.hero-slide{position:absolute;inset:0;opacity:0;transition:opacity 1.2s cubic-bezier(0.4,0,0.2,1);will-change:opacity;}
.hero-slide.active{opacity:1;z-index:1;}
.hero-slide>img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center;display:block;transform:scale(1.05);transition:transform 6s ease;}
.hero-slide.active>img{transform:scale(1);}
.hero-slide::after{content:'';position:absolute;inset:0;background:linear-gradient(135deg,rgba(7,42,66,0.72) 0%,rgba(11,60,93,0.45) 50%,rgba(35,156,186,0.15) 100%);z-index:1;}
.slide-caption{position:absolute;bottom:0;left:0;right:0;z-index:3;padding:60px 60px 100px;background:linear-gradient(to top,rgba(7,42,66,0.9) 0%,transparent 100%);transform:translateY(20px);opacity:0;transition:all 0.8s ease 0.4s;}
.hero-slide.active .slide-caption{transform:translateY(0);opacity:1;}
.slide-caption-tag{display:inline-flex;align-items:center;gap:8px;background:rgba(35,156,186,0.25);border:1px solid rgba(35,156,186,0.5);color:var(--accent-light);font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase;padding:6px 16px;border-radius:50px;margin-bottom:16px;}
.slide-caption h2{font-size:clamp(28px,4vw,52px);font-weight:900;color:#fff;line-height:1.15;margin-bottom:12px;letter-spacing:-0.5px;text-shadow:0 2px 20px rgba(0,0,0,0.3);}
.slide-caption h2 span{color:var(--accent-light);}
.slide-caption p{font-size:16px;color:rgba(255,255,255,0.75);max-width:560px;line-height:1.65;font-weight:400;}
.hero-particles{position:absolute;inset:0;z-index:2;pointer-events:none;overflow:hidden;}
.hero-particle{position:absolute;border-radius:50%;background:rgba(35,156,186,0.15);animation:floatParticle linear infinite;}
@keyframes floatParticle{0%{transform:translateY(100vh) scale(0);opacity:0;}10%{opacity:1;}90%{opacity:0.5;}100%{transform:translateY(-100px) scale(1);opacity:0;}}
.slider-progress{position:absolute;bottom:0;left:0;height:3px;background:var(--accent);z-index:10;width:0;}
.slider-progress.running{animation:sliderBar 5s linear forwards;}
@keyframes sliderBar{from{width:0;}to{width:100%;}}
.slider-dots{position:absolute;bottom:40px;right:60px;z-index:10;display:flex;gap:8px;}
.slider-dot{width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,0.3);cursor:pointer;transition:all 0.3s;border:none;}
.slider-dot.active{background:var(--accent);width:24px;border-radius:4px;}
.slider-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:10;width:48px;height:48px;border-radius:50%;background:rgba(255,255,255,0.1);border:1px solid rgba(255,255,255,0.25);color:#fff;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all 0.3s;}
.slider-arrow:hover{background:var(--accent);border-color:var(--accent);box-shadow:0 8px 24px rgba(35,156,186,0.5);}
.slider-prev{left:32px;}.slider-next{right:32px;}
.slide-counter{position:absolute;top:100px;right:60px;z-index:10;font-size:13px;font-weight:700;color:rgba(255,255,255,0.5);letter-spacing:2px;}
.slide-counter .current{font-size:28px;font-weight:900;color:#fff;}
.scroll-indicator{position:absolute;bottom:36px;left:60px;z-index:10;display:flex;align-items:center;gap:12px;color:rgba(255,255,255,0.5);font-size:11px;font-weight:600;letter-spacing:2px;text-transform:uppercase;}
.scroll-mouse{width:22px;height:36px;border:2px solid rgba(255,255,255,0.3);border-radius:11px;display:flex;justify-content:center;padding-top:6px;}
.scroll-mouse::before{content:'';width:3px;height:7px;background:rgba(255,255,255,0.6);border-radius:2px;animation:scrollBounce 1.8s ease infinite;}
@keyframes scrollBounce{0%,100%{transform:translateY(0);opacity:1;}50%{transform:translateY(6px);opacity:0.3;}}
/* VIDEO */
#video-section{background:var(--light);padding:80px 0;}
.video-wrapper{position:relative;padding-bottom:56.25%;height:0;overflow:hidden;border-radius:20px;box-shadow:0 24px 80px rgba(11,60,93,0.2);margin-top:48px;}
.video-wrapper iframe{position:absolute;top:0;left:0;width:100%;height:100%;border:none;border-radius:20px;}
/* TRUST */
#trust{background:var(--primary);padding:48px 0;border-bottom:1px solid rgba(255,255,255,0.08);}
.trust-inner{display:grid;grid-template-columns:repeat(6,1fr);gap:16px;align-items:stretch;}
.trust-badge{display:flex;flex-direction:column;align-items:center;text-align:center;gap:14px;padding:28px 20px;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:16px;text-decoration:none;transition:all 0.3s ease;cursor:pointer;}
.trust-badge:hover{transform:translateY(-6px);box-shadow:0 16px 40px rgba(0,0,0,0.25);background:rgba(35,156,186,0.12);border-color:rgba(35,156,186,0.35);}
.trust-badge-icon{width:56px;height:56px;background:rgba(35,156,186,0.2);border-radius:14px;display:flex;align-items:center;justify-content:center;font-size:26px;color:#ffffff;flex-shrink:0;}
.trust-badge-text strong{display:block;font-size:14px;font-weight:700;color:var(--white);margin-bottom:4px;}
.trust-badge-text span{font-size:12px;color:rgba(255,255,255,0.55);font-weight:500;}
/* PROBLEM */
#problem{background:var(--light);}
.problem-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(240px,1fr));gap:24px;margin:56px 0 48px;}
.problem-card{background:var(--white);border-radius:18px;padding:32px 28px;border:1px solid var(--border);position:relative;overflow:hidden;transition:all 0.3s ease;}
.problem-card::before{content:'';position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,var(--accent),var(--primary));transform:scaleX(0);transform-origin:left;transition:transform 0.35s ease;}
.problem-card:hover{transform:translateY(-6px);box-shadow:0 20px 48px rgba(11,60,93,0.12);}
.problem-card:hover::before{transform:scaleX(1);}
.problem-icon{width:54px;height:54px;background:linear-gradient(135deg,rgba(35,156,186,0.1),rgba(11,60,93,0.08));border-radius:14px;display:flex;align-items:center;justify-content:center;font-size:24px;color:var(--accent);margin-bottom:20px;}
.problem-card h3{font-size:16px;font-weight:700;color:var(--primary);margin-bottom:10px;}
.problem-card p{font-size:14px;color:var(--text-muted);line-height:1.65;margin:0;}
.problem-cta{text-align:center;margin-top:8px;}
/* ECOSYSTEM */
#ecosystem{background:var(--primary-dark);}
#ecosystem .section-title{color:var(--white);}
#ecosystem .section-sub{color:rgba(255,255,255,0.6);}
#ecosystem .tag{background:rgba(35,156,186,0.15);}
.eco-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;margin-top:52px;}
.eco-card{background:rgba(255,255,255,0.04);border:1px solid rgba(255,255,255,0.08);border-radius:18px;padding:32px 24px;transition:all 0.35s ease;position:relative;overflow:hidden;}
.eco-card:hover{border-color:rgba(35,156,186,0.35);transform:translateY(-6px);box-shadow:0 24px 48px rgba(0,0,0,0.3);}
.eco-num{font-size:11px;font-weight:700;letter-spacing:2px;color:var(--accent);margin-bottom:20px;display:block;}
.eco-icon{width:56px;height:56px;background:linear-gradient(135deg,rgba(35,156,186,0.2),rgba(35,156,186,0.08));border-radius:16px;display:flex;align-items:center;justify-content:center;font-size:26px;color:var(--accent);margin-bottom:20px;border:1px solid rgba(35,156,186,0.2);}
.eco-card h3{font-size:17px;font-weight:700;color:var(--white);margin-bottom:10px;}
.eco-header{display:flex;align-items:center;gap:14px;margin-bottom:14px;}
.eco-header .eco-icon{margin-bottom:0;flex-shrink:0;}
.eco-header h3{margin:0;}
.eco-card p{font-size:14px;color:rgba(255,255,255,0.6);line-height:1.65;margin-bottom:16px;}
.eco-tags{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:4px;}
.eco-tag{font-size:11px;font-weight:700;letter-spacing:0.5px;color:var(--accent);background:rgba(35,156,186,0.12);border:1px solid rgba(35,156,186,0.2);padding:3px 10px;border-radius:20px;}
.eco-video{position:relative;padding-bottom:56.25%;height:0;overflow:hidden;border-radius:12px;margin-top:20px;}
.eco-video iframe{position:absolute;top:0;left:0;width:100%;height:100%;border:none;border-radius:12px;}
/* VALUE */
.value-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:24px;margin-top:52px;}
.value-card{background:var(--white);border-radius:18px;padding:20px 24px;border:1px solid var(--border);transition:all 0.3s;display:flex;flex-direction:column;align-items:center;text-align:center;border: 1px solid var(--border);}
.value-card:hover{transform:translateY(-5px);box-shadow: 0 16px 40px rgba(11, 60, 93, 0.1);border-color: rgba(35, 156, 186, 0.25);}
.value-card-icon{width:64px;height:64px;background: linear-gradient(135deg, var(--primary), var(--primary-light));;border-radius:18px;display:flex;align-items:center;justify-content:center;font-size:28px;color:var(--accent);box-shadow: 0 8px 24px rgba(11, 60, 93, 0.2); margin: 0 auto 20px;}
.value-card h3{font-size:16px;font-weight:700;color:var(--primary);margin-bottom:10px; margin-top:0px;text-align:center;white-space:nowrap;}
.value-card p{font-size:14px;color:var(--text-muted);line-height:1.65;text-align:center;}
/* COMPLIANCE */
#compliance{background:var(--white);}
.compliance-table-wrapper{width:100%;overflow-x:auto;margin-top:52px;border-radius:16px;box-shadow:0 8px 40px rgba(11,60,93,0.1);-webkit-overflow-scrolling:touch;}
.compliance-table{width:100%;min-width:640px;border-collapse:separate;border-spacing:0;border-radius:16px;overflow:hidden;}
.compliance-table thead th{background:var(--primary);color:var(--white);font-size:13px;font-weight:700;padding:20px 24px;text-align:left;letter-spacing:0.5px;}
.compliance-table tbody tr{transition:background 0.2s;}
.compliance-table tbody tr:nth-child(even){background:var(--light);}
.compliance-table tbody tr:hover{background:rgba(35,156,186,0.06);}
.compliance-table td{padding:20px 24px;font-size:14px;border-bottom:1px solid var(--gray);vertical-align:middle;}
.compliance-table td:first-child{color:var(--text);font-weight:600;}
.compliance-table td:nth-child(2){color:var(--primary);font-weight:600;}
.compliance-table td:nth-child(3){color:var(--success);font-weight:600;white-space:nowrap;}
.compliance-table td:nth-child(4){color:var(--text-muted);font-size:13px;line-height:1.55;}
.compliance-table tr:last-child td{border-bottom:none;}
.check-icon{width:22px;height:22px;background:rgba(39,174,96,0.15);border-radius:50%;display:inline-flex;align-items:center;justify-content:center;font-size:11px;color:var(--success);flex-shrink:0;margin-right:6px;}
/* COMPARISON */
.comparison{background: var(--white);}
.compare-wrapper{display:grid;grid-template-columns:1fr 1fr;gap:24px;margin-top:52px;}
.compare-col{border-radius:18px;overflow:hidden;box-shadow: 0 8px 36px rgba(11, 60, 93, 0.1);}

.compare-header{padding: 22px 28px;;font-size:15px;font-weight:700;display:flex;align-items:center;gap:10px;}
.compare-col.old .compare-header{  background: #f0f0f0;color: #6b7280;}
.compare-col.new .compare-header{  background: linear-gradient(135deg, var(--primary), var(--primary-light));
      color: var(--white);}
      .compare-col.new .compare-header .span{color: var(--accent-light);}
.compare-items{ padding: 8px 0;  background: var(--white);}
.compare-item{display:flex;align-items:flex-start;gap:14px;padding: 16px 28px;border-bottom: 1px solid var(--gray);font-size: 14px;}
.compare-item:last-child{border-bottom:none;}
.compare-icon{font-size:14px;margin-top:2px;flex-shrink:0;}
.compare-col.old .compare-icon{ color: #ef4444;  font-size: 16px;margin-top: 1px;}
.compare-col.new .compare-icon{   color: var(--success);font-size: 16px;margin-top: 1px;}
  .compare-col.old .compare-item {
      color: #6b7280;
    }
         .compare-col.new .compare-item {
      color: var(--text);
      font-weight: 500;
    }

/* SOCIAL PROOF */
#social{background:var(--primary);}
#social .section-title{color:var(--white);}
#social .section-sub{color:rgba(255,255,255,0.6);}
#social .tag{background:rgba(35,156,186,0.15);}
.metrics-row{display:flex;justify-content:center;gap:60px;margin:52px 0;flex-wrap:wrap;}
.metric{text-align:center;}
.metric-num{font-size:clamp(36px,5vw,54px);font-weight:900;color:var(--white);line-height:1;margin-bottom:8px;}
.metric-num span{color:var(--accent);}
.metric-label{font-size:13px;color:rgba(255,255,255,0.5);font-weight:500;letter-spacing:0.5px;}
.clients-row{display:flex;justify-content:center;flex-wrap:wrap;gap:16px;margin-top:52px;}
.client-chip{background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.1);border-radius:12px;padding:14px 28px;font-size:15px;font-weight:700;color:rgba(255,255,255,0.65);transition:all 0.25s;}
.client-chip:hover{background:rgba(35,156,186,0.12);border-color:rgba(35,156,186,0.3);color:var(--white);}
/* SECURITY */
#security{background:var(--light);}
.security-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;margin-top:52px;}
.security-eco-card{background:#ffffff;border-radius:18px;padding:32px;border:1px solid var(--border);transition:all 0.35s ease;}
.security-eco-card:hover{border-color:rgba(35,156,186,0.35);transform:translateY(-6px);box-shadow:0 24px 48px rgba(11,60,93,0.1);}
.security-eco-card .eco-icon{background:linear-gradient(135deg,rgba(35,156,186,0.2),rgba(35,156,186,0.08));}
.security-eco-card h3{color:var(--primary);}
.security-eco-card p{color:var(--text-muted);}
/* WORKFLOW */
#workflow-ecosystem{background:var(--primary-dark);}
#workflow-ecosystem .section-title{color:var(--white);}
#workflow-ecosystem .section-sub{color:rgba(255,255,255,0.65);}
#workflow-ecosystem .tag{background:rgba(35,156,186,0.15);}
.workflow-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:24px;margin-top:52px;}
.workflow-card{background:rgba(255,255,255,0.04);border:1px solid rgba(255,255,255,0.08);border-radius:20px;padding:36px 32px;transition:all 0.35s ease;position:relative;overflow:hidden;}
.workflow-card::before{content:'';position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,var(--accent),var(--accent-light));transform:scaleX(0);transform-origin:left;transition:transform 0.4s ease;}
.workflow-card:hover{border-color:rgba(35,156,186,0.35);transform:translateY(-6px);box-shadow:0 24px 56px rgba(0,0,0,0.3);}
.workflow-card:hover::before{transform:scaleX(1);}
.workflow-card-num{font-size:11px;font-weight:700;letter-spacing:2px;color:var(--accent);margin-bottom:16px;display:block;}
.workflow-card-icon{width:60px;height:60px;background:linear-gradient(135deg,rgba(35,156,186,0.2),rgba(35,156,186,0.06));border-radius:16px;display:flex;align-items:center;justify-content:center;font-size:28px;color:var(--accent);margin-bottom:20px;border:1px solid rgba(35,156,186,0.2);}
.workflow-card h3{font-size:18px;font-weight:800;color:var(--white);margin-bottom:14px;line-height:1.3;}
.workflow-header{display:flex;align-items:center;gap:16px;margin-bottom:14px;}
.workflow-header .workflow-card-icon{margin-bottom:0;flex-shrink:0;}
.workflow-header h3{margin:0;}
.workflow-card ul{list-style:none;margin-top:16px;display:flex;flex-direction:column;gap:8px;}
.workflow-card ul li{font-size:13px;color:rgba(255,255,255,0.6);display:flex;align-items:flex-start;gap:10px;line-height:1.55;}
.workflow-card ul li::before{content:'';width:6px;height:6px;background:var(--accent);border-radius:50%;flex-shrink:0;margin-top:6px;}
/* FAQ */
#faq{background:var(--white);}
.faq-tabs{display:flex;gap:10px;flex-wrap:wrap;margin-bottom:36px;margin-top:40px;}
.faq-tab{padding:9px 22px;border-radius:50px;font-size:13px;font-weight:600;cursor:pointer;border:2px solid var(--border);background:transparent;color:var(--text-muted);transition:all 0.25s;font-family:'Montserrat',sans-serif;}
.faq-tab.active,.faq-tab:hover{background:var(--primary);border-color:var(--primary);color:var(--white);}
.faq-item{border:1px solid var(--border);border-radius:14px;margin-bottom:12px;overflow:hidden;}
.faq-q{padding:20px 24px;font-size:15px;font-weight:600;color:var(--primary);cursor:pointer;display:flex;align-items:center;justify-content:space-between;gap:16px;background:var(--white);user-select:none;transition:background 0.2s;}
.faq-q:hover{background:var(--light);}
.faq-item.open .faq-q{background:var(--light);}
.faq-chevron{transition:transform 0.3s;flex-shrink:0;color:var(--text-muted);}
.faq-item.open .faq-chevron{transform:rotate(180deg);}
.faq-a{padding:0 24px;max-height:0;overflow:hidden;transition:max-height 0.35s ease,padding 0.35s ease;font-size:14px;color:var(--text-muted);line-height:1.7;}
.faq-item.open .faq-a{max-height:1200px;padding:24px 24px 20px;}
.faq-a .faq-list{margin:12px 0 4px 8px;display:flex;flex-direction:column;gap:8px;list-style:none;}
.faq-a .faq-list li{display:flex;align-items:flex-start;gap:10px;font-size:14px;color:var(--text-muted);line-height:1.65;}
.faq-a .faq-list li::before{content:'';width:6px;height:6px;background:var(--text-muted);border-radius:50%;flex-shrink:0;margin-top:7px;}
.faq-group-note{font-size:13px;color:var(--text-muted);margin-bottom:20px;font-style:italic;}
/* CTA FINAL */
#cta-final .section-title{color:var(--white);}
#cta-final{background:linear-gradient(135deg,var(--primary-dark) 0%,#0d4a73 60%,var(--primary) 100%);padding:100px 0;position:relative;overflow:hidden;}
#cta-final::before{content:'';position:absolute;inset:0;background-image:linear-gradient(rgba(35,156,186,0.06) 1px,transparent 1px),linear-gradient(90deg,rgba(35,156,186,0.06) 1px,transparent 1px);background-size:50px 50px;}
.cta-accent-line{font-size:36px;color:var(--accent-light);margin: 0 auto 36px;line-height:1.7;text-align:center;}
/* FOOTER */
footer{background:var(--primary-dark);padding:72px 0 0;}
.footer-inner{display:grid;grid-template-columns:2fr 1fr 1fr;gap:48px;padding-bottom:60px;border-bottom:1px solid rgba(255,255,255,0.08);}
.footer-brand p{font-size:14px;color:rgba(255,255,255,0.45);line-height:1.7;margin-top:16px;}
.footer-socials{display:flex;gap:10px;margin-top:20px;}
.footer-social{width:38px;height:38px;background:rgba(255,255,255,0.06);border-radius:10px;display:flex;align-items:center;justify-content:center;color:rgba(255,255,255,0.45);font-size:14px;text-decoration:none;transition:all 0.25s;}
.footer-social:hover{background:var(--accent);color:#fff;}
.footer-col h5{font-size:13px;font-weight:700;color:rgba(255,255,255,0.9);letter-spacing:0.5px;margin-bottom:20px;text-transform:uppercase;}
.footer-col a{display:block;font-size:14px;color:rgba(255,255,255,0.45);text-decoration:none;margin-bottom:12px;transition:color 0.2s;}
.footer-col a:hover{color:var(--accent-light);}
.footer-bottom{display:flex;align-items:center;justify-content:space-between;padding:24px 0;flex-wrap:wrap;gap:12px;}
.footer-bottom p{font-size:12px;color:rgba(255,255,255,0.3);}
.footer-bottom a{color:rgba(255,255,255,0.3);text-decoration:none;font-size:12px;transition:color 0.2s;}
.footer-bottom a:hover{color:var(--accent);}
/* DEMO MODAL */
.demo-modal-backdrop{position:fixed;inset:0;z-index:9999;background:rgba(7,42,66,0.75);backdrop-filter:blur(6px);overflow-y:auto;padding:40px 20px;display:flex;align-items:flex-start;justify-content:center;}
.demo-modal{max-width:600px;width:100%;background:#fff;border-radius:24px;box-shadow:0 32px 80px rgba(11,60,93,0.35);overflow:hidden;}
.demo-modal-header{background:linear-gradient(135deg,#0B3C5D 0%,#1a5276 100%);padding:32px 36px 28px;position:relative;}
.demo-modal-close{position:absolute;top:20px;right:24px;background:rgba(255,255,255,0.12);border:none;color:#fff;width:36px;height:36px;border-radius:50%;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background 0.2s;}
.demo-modal-close:hover{background:rgba(255,255,255,0.25);}
.demo-modal-body{padding:32px 36px 36px;}
.demo-form-msg{border-radius:12px;padding:14px 18px;margin-bottom:20px;font-size:14px;font-weight:600;font-family:'Montserrat',sans-serif;}
.demo-form-msg.error{background:#fdecea;border:1px solid #e74c3c;color:#c0392b;}
.demo-form-msg.success{background:#e8f8ed;border:1px solid #27ae60;color:#1a7a40;}
.form-group{margin-bottom:18px;}
.form-label{display:block;font-size:13px;font-weight:700;color:#1a2b38;margin-bottom:7px;}
.form-input{width:100%;padding:12px 16px;border:1.5px solid #e8eef4;border-radius:10px;font-family:'Montserrat',sans-serif;font-size:14px;color:#1a2b38;outline:none;transition:border-color 0.2s;}
.form-input:focus{border-color:#239CBA;}
.form-textarea{width:100%;padding:12px 16px;border:1.5px solid #e8eef4;border-radius:10px;font-family:'Montserrat',sans-serif;font-size:14px;color:#1a2b38;outline:none;resize:vertical;transition:border-color 0.2s;}
.form-textarea:focus{border-color:#239CBA;}
.radio-group{display:flex;flex-wrap:wrap;gap:10px;}
.radio-label{display:flex;align-items:center;gap:8px;padding:9px 16px;border:1.5px solid #e8eef4;border-radius:8px;cursor:pointer;font-size:13px;font-weight:600;color:#1a2b38;transition:all 0.2s;}
.radio-label.checked{border-color:#239CBA;background:rgba(35,156,186,0.07);color:#0B3C5D;}
.form-actions{display:flex;gap:12px;flex-wrap:wrap;}
.form-submit{flex:1;min-width:160px;display:inline-flex;align-items:center;justify-content:center;gap:9px;padding:14px 28px;border-radius:50px;font-family:'Montserrat',sans-serif;font-weight:700;font-size:14px;background:linear-gradient(135deg,#239CBA 0%,#1a7fa0 100%);color:#fff;border:none;cursor:pointer;box-shadow:0 6px 28px rgba(35,156,186,0.4);transition:all 0.28s;}
.form-submit:hover{transform:translateY(-2px);box-shadow:0 12px 36px rgba(35,156,186,0.55);}
.form-reset{flex:1;min-width:120px;display:inline-flex;align-items:center;justify-content:center;gap:9px;padding:14px 28px;border-radius:50px;font-family:'Montserrat',sans-serif;font-weight:700;font-size:14px;background:transparent;color:#5a7a8a;border:2px solid #e8eef4;cursor:pointer;transition:all 0.28s;}
.form-reset:hover{border-color:#239CBA;color:#239CBA;}
/* Responsive */
@media(max-width:1024px){
  .eco-grid{grid-template-columns:repeat(2,1fr);}
  .trust-inner{grid-template-columns:repeat(3,1fr);}
  .footer-inner{grid-template-columns:1fr 1fr;}
}
@media(max-width:768px){
  .nav-links,.nav-cta{display:none;}
  .hamburger{display:flex;}
  .mobile-menu-overlay{position:fixed;inset:0;background:rgba(7,42,66,0.97);backdrop-filter:blur(12px);z-index:2000;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:0;}
  .mobile-menu-overlay ul{list-style:none;display:flex;flex-direction:column;align-items:center;gap:8px;width:100%;}
  .mobile-menu-overlay ul li a{font-size:22px;font-weight:700;color:#fff;text-decoration:none;display:block;padding:14px 40px;letter-spacing:0.3px;transition:color 0.2s;}
  .mobile-menu-overlay ul li a:hover{color:var(--accent-light);}
  .mobile-menu-overlay .mobile-cta{margin-top:32px;}
  .mobile-menu-close{position:absolute;top:20px;right:24px;background:none;border:none;color:#fff;font-size:28px;cursor:pointer;line-height:1;padding:8px;}
  .hero-slider{height:100svh;min-height:500px;}
  .slide-caption{padding:32px 24px 80px;}
  .slide-caption h2{font-size:clamp(22px,6vw,36px);}
  .slider-dots{right:24px;bottom:24px;}
  .scroll-indicator{left:24px;}
  .slide-counter{right:24px;top:90px;}
  .slider-prev{left:16px;}.slider-next{right:16px;}
  .eco-grid,.security-grid,.workflow-grid{grid-template-columns:1fr;}
  .compare-wrapper{grid-template-columns:1fr;}
  .trust-inner{grid-template-columns:repeat(2,1fr);}
  .footer-inner{grid-template-columns:1fr;}
}
@media(max-width:480px){
  .metrics-row{gap:32px;}
  .trust-inner{grid-template-columns:1fr 1fr;}
}
`;

/* ─── HOOKS ─── */
function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("visible");
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 },
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);
}

/* ─── SUB-COMPONENTS ─── */

function Navbar({ t, i18n, onOpenModal }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
    const [langOpen, setLangOpen] = useState(false);
  const langRef = useRef(null);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

   useEffect(() => {
    const handleClickOutside = (e) => {
      if (langRef.current && !langRef.current.contains(e.target)) {
        setLangOpen(false);
      }
    };
    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

   // mount lại đúng basename (giống NavbarTop/NavbarBottom).
  const handleChangeLanguage = (language) => {
    const newPath = window.location.pathname.replace(
      /^\/(en|vi)/,
      `/${language}`,
    );
    window.location.href = `${newPath}${window.location.search}${window.location.hash}`;
  };


  const close = () => setMenuOpen(false);

  const NAV_LINKS = [
    ["#problem", t("landing.header.problem")],
    ["#ecosystem", t("landing.header.solution")],
    ["#compliance", t("landing.header.legal")],
    ["#comparison", t("landing.header.compare")],
    ["#social", t("landing.header.customer")],
    ["#faq", t("landing.header.FAQ")],
  ];

  return (
    <>
      <nav id="navbar" className={scrolled ? "scrolled" : ""}>
        <div className="nav-inner">
          <a href="#" className="nav-logo">
            <img
              src={Logo}
              alt="GoPaperless Logo"
              style={{ height: 44, width: "auto", objectFit: "contain" }}
            />
          </a>
          <ul className="nav-links">
            {NAV_LINKS.map(([href, label]) => (
              <li key={href}>
                <a href={href}>{label}</a>
              </li>
            ))}
          </ul>
          <div className="nav-cta">
            <button
              onClick={onOpenModal}
              className="btn-landing btn-landing-primary-landing"
              style={{ padding: "10px 24px", fontSize: 13 }}
            >
              <i className="fas fa-calendar-check" /> {t("landing.header.demo")}
            </button>
             <div className="lang-dd-wrap" ref={langRef}>
              <button
                type="button"
                className="lang-dd-toggle"
                onClick={() => setLangOpen((v) => !v)}
                aria-haspopup="true"
                aria-expanded={langOpen}
              >
                <img
                  src={i18n.language === "en" ? en8 : vn8}
                  alt={i18n.language === "en" ? "en" : "vi"}
                />
                <i
                  className={`fas fa-chevron-down lang-dd-icon${
                    langOpen ? " open" : ""
                  }`}
                />
              </button>
              {langOpen && (
                <ul className="lang-dd-menu">
                  <li>
                    <button
                      type="button"
                      className={i18n.language === "en" ? "active" : ""}
                      onClick={() => handleChangeLanguage("en")}
                    >
                      <img src={en8} alt="en" /> English
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      className={i18n.language === "vi" ? "active" : ""}
                      onClick={() => handleChangeLanguage("vi")}
                    >
                      <img src={vn8} alt="vi" /> Tiếng Việt
                    </button>
                  </li>
                </ul>
              )}
            </div>

          </div>
          <button
            className="hamburger"
            aria-label="Menu"
            onClick={() => setMenuOpen(true)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>

      {/* Mobile overlay — hoàn toàn tách riêng khỏi navbar */}
      {menuOpen && (
        <div className="mobile-menu-overlay">
          <button className="mobile-menu-close" onClick={close}>
            ×
          </button>
          <ul>
            {NAV_LINKS.map(([href, label]) => (
              <li key={href}>
                <a href={href} onClick={close}>
                  {label}
                </a>
              </li>
            ))}
          </ul>
          <div className="mobile-cta">
            <button
              onClick={() => {
                onOpenModal();
                close();
              }}
              className="btn-landing btn-landing-primary-landing"
              style={{ fontSize: 15, padding: "12px 32px" }}
            >
              <i className="fas fa-calendar-check" /> {t("landing.header.demo")}
            </button>
             <div className="mobile-lang-switch">
              <button
                type="button"
                className={`mobile-lang-option${
                  i18n.language === "en" ? " active" : ""
                }`}
                onClick={() => handleChangeLanguage("en")}
              >
                <img src={en8} alt="en" /> English
              </button>
              <button
                type="button"
                className={`mobile-lang-option${
                  i18n.language === "vi" ? " active" : ""
                }`}
                onClick={() => handleChangeLanguage("vi")}
              >
                <img src={vn8} alt="vi" /> Tiếng Việt
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function HeroSlider({ t, i18n, onOpenModal }) {
  const SLIDES = [
    {
      img: i18n.language === "en" ? Hero1E : Hero1,
      tag: { icon: "fas fa-sitemap", text: t("landing.hero.p1.title") },
      title: (
        <>
          {t("landing.hero.p1.sub1")}
          <br />
          <span>{t("landing.hero.p1.sub2")}</span>
        </>
      ),
      desc: t("landing.hero.p1.desc"),
    },
    {
      img: i18n.language === "en" ? Hero2E : Hero2,
      tag: { icon: "fas fa-id-card", text: t("landing.hero.p2.title") },
      title: (
        <>
          {t("landing.hero.p2.sub1")} <span>{t("landing.hero.p2.sub11")}</span>
          <br />
          {t("landing.hero.p2.sub2")}
        </>
      ),
      desc: t("landing.hero.p2.desc"),
    },
    {
      img: i18n.language === "en" ? Hero3E : Hero3,
      tag: { icon: "fas fa-code", text: t("landing.hero.p3.title") },
      title: (
        <>
          {t("landing.hero.p3.sub1")} <span>{t("landing.hero.p3.sub11")}</span>
          <br />
          {t("landing.hero.p3.sub2")}
        </>
      ),
      desc: t("landing.hero.p3.desc"),
    },
    {
      img: i18n.language === "en" ? Hero4E : Hero4,
      tag: { icon: "fas fa-code", text: t("landing.hero.p4.title") },
      title: (
        <>
          {t("landing.hero.p4.sub1")} <br /> {t("landing.hero.p4.sub2")}
        </>
      ),
      desc: t("landing.hero.p4.desc"),
    },
  ];
  const [current, setCurrent] = useState(0);
  const [progressKey, setProgressKey] = useState(0);
  const timerRef = useRef(null);
  const touchStartRef = useRef(0);
  const currentRef = useRef(0);

  const pad = (n) => (n < 10 ? "0" + n : "" + n);

  const goTo = useCallback((idx) => {
    const next = ((idx % SLIDES.length) + SLIDES.length) % SLIDES.length;
    currentRef.current = next;
    setCurrent(next);
    setProgressKey((k) => k + 1);
  }, []);

  const startAuto = useCallback(() => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      goTo(currentRef.current + 1);
    }, 5000);
  }, [goTo]);

  useEffect(() => {
    startAuto();
    return () => clearInterval(timerRef.current);
  }, [startAuto]);

  useEffect(() => {
    const fn = (e) => {
      if (e.key === "ArrowRight") {
        goTo(currentRef.current + 1);
        startAuto();
      }
      if (e.key === "ArrowLeft") {
        goTo(currentRef.current - 1);
        startAuto();
      }
    };
    window.addEventListener("keydown", fn);
    return () => window.removeEventListener("keydown", fn);
  }, [goTo, startAuto]);

  // Particles
  const particles = useRef(
    Array.from({ length: 12 }, (_, i) => ({
      size: Math.random() * 60 + 20,
      left: Math.random() * 100,
      dur: Math.random() * 12 + 8,
      delay: Math.random() * 8,
      opacity: Math.random() * 0.15 + 0.05,
    })),
  ).current;

  return (
    <section id="hero">
      <div
        className="hero-slider"
        onTouchStart={(e) => {
          touchStartRef.current = e.touches[0].clientX;
        }}
        onTouchEnd={(e) => {
          const diff = touchStartRef.current - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 50) {
            diff > 0 ? goTo(current + 1) : goTo(current - 1);
            startAuto();
          }
        }}
      >
        {/* Particles */}
        <div className="hero-particles">
          {particles.map((p, i) => (
            <div
              key={i}
              className="hero-particle"
              style={{
                width: p.size,
                height: p.size,
                left: p.left + "%",
                animationDuration: p.dur + "s",
                animationDelay: p.delay + "s",
                opacity: p.opacity,
              }}
            />
          ))}
        </div>

        {SLIDES.map((s, i) => (
          <div
            key={i}
            className={`hero-slide${i === current ? " active" : ""}`}
          >
            <img src={s.img} alt={s.title} />
            <div className="slide-caption">
              <div className="slide-caption-tag">
                <i className={s.tag.icon} /> {s.tag.text}
              </div>
              <h2 style={{ marginTop: 0 }}>{s.title}</h2>
              <p>{s.desc}</p>
            </div>
          </div>
        ))}

        <div key={progressKey} className="slider-progress running" />

        <div className="slide-counter">
          <span className="current">{pad(current + 1)}</span> /{" "}
          {pad(SLIDES.length)}
        </div>

        <div className="slider-dots">
          {SLIDES.map((_, i) => (
            <span
              key={i}
              className={`slider-dot${i === current ? " active" : ""}`}
              onClick={() => {
                goTo(i);
                startAuto();
              }}
            />
          ))}
        </div>

        <button
          className="slider-arrow slider-prev"
          onClick={() => {
            goTo(current - 1);
            startAuto();
          }}
        >
          <i className="fas fa-chevron-left" />
        </button>
        <button
          className="slider-arrow slider-next"
          onClick={() => {
            goTo(current + 1);
            startAuto();
          }}
        >
          <i className="fas fa-chevron-right" />
        </button>

        <div className="scroll-indicator">
          <div className="scroll-mouse" />
          {t("landing.hero.scroll-down")}
        </div>
      </div>
    </section>
  );
}

function VideoSection({ t, i18n }) {
  return (
    <section id="video-section">
      <div className="gp-container">
        <div className="reveal" style={{ textAlign: "center" }}>
          <span className="tag">{t("landing.video.demo")}</span>
          <h2 className="section-title" style={{ marginTop: 0 }}>
            {t("landing.video.title")}
          </h2>
          <p className="section-sub" style={{ margin: "0 auto" }}>
            {t("landing.video.sub1")}
            <br />
            {t("landing.video.sub2")}
          </p>
        </div>
        <div className="video-wrapper reveal">
          <iframe
            src="https://www.youtube-nocookie.com/embed/CgvmfcTjLSo"
            title="GoPaperless Demo"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            referrerpolicy="strict-origin-when-cross-origin"
          />
        </div>
      </div>
    </section>
  );
}

function TrustSection({ t, i18n }) {
  const TRUST_BADGES = [
    {
      icon: "fas fa-file-signature",
      title: t("landing.trust.c1.title"),
      sub: t("landing.trust.c1.sub"),
    },
    {
      icon: "fas fa-file-alt",
      title: t("landing.trust.c2.title"),
      sub: (
        <>
          {t("landing.trust.c2.sub")}
          {i18n.language === "vi" ? <br /> : null}
          {t("landing.trust.c2.sub2")}
        </>
      ),
    },
    {
      icon: "fas fa-shield-alt",
      title: t("landing.trust.c3.title"),
      sub: (
        <>
          {t("landing.trust.c3.sub")}
          <br />
          {t("landing.trust.c3.sub2")}
        </>
      ),
    },
    {
      icon: "fas fa-id-card",
      title: t("landing.trust.c4.title"),
      sub: t("landing.trust.c4.sub"),
      largeGap: true,
    },
    {
      icon: "fas fa-file-signature",
      title: t("landing.trust.c5.title"),
      sub: t("landing.trust.c5.sub"),
    },
    {
      icon: "fas fa-certificate",
      title: t("landing.trust.c6.title"),
      sub: t("landing.trust.c6.sub"),
      largeGap: true,
    },
  ];
  return (
    <section id="trust">
      <div className="gp-container">
        <div className="trust-inner">
          {TRUST_BADGES.map((b, i) => (
            <a
              key={i}
              href="#compliance"
              className="trust-badge"
              style={{ color: "#ffffff", textDecoration: "none" }}
            >
              <div className="trust-badge-icon">
                <i className={b.icon} />
              </div>
              <div className="trust-badge-text">
                <strong
                  style={{
                    marginBottom: b.largeGap ? "26px" : "",
                  }}
                >
                  {b.title}
                </strong>
                <span>{b.sub}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

function ProblemSection({ t, i18n, onOpenModal }) {
  const PROBLEMS = [
    {
      icon: "fas fa-clock",
      title: t("landing.problem.c1.title"),
      desc: t("landing.problem.c1.desc"),
    },
    {
      icon: "fas fa-exclamation-triangle",
      title: t("landing.problem.c2.title"),
      desc: t("landing.problem.c2.desc"),
      breakAfterTitle: i18n === "vi" ? true : false,
    },
    {
      icon: "fas fa-puzzle-piece",
      title: t("landing.problem.c3.title"),
      desc: t("landing.problem.c3.desc"),
      breakAfterTitle: true,
    },
    {
      icon: "fas fa-user-times",
      title: t("landing.problem.c4.title"),
      desc: t("landing.problem.c4.desc"),
    },
  ];
  return (
    <section id="problem" className="section-pad">
      <div className="gp-container">
        <div className="reveal">
          <span className="tag">{t("landing.problem.challenge")}</span>
          <h2 className="section-title" style={{ marginTop: 0 }}>
            {t("landing.problem.title")}
          </h2>
          <p className="section-sub">{t("landing.problem.sub")}</p>
        </div>
        <div className="problem-grid">
          {PROBLEMS.map((p, i) => (
            <div key={i} className="problem-card reveal">
              <div className="problem-icon">
                <i className={p.icon} />
              </div>
              <h3 style={{ lineHeight: 1.6 }}>{p.title}</h3>
              {p.breakAfterTitle && <br />}
              <p>{p.desc}</p>
            </div>
          ))}
        </div>
        <div className="problem-cta reveal">
          <a
            href="#ecosystem"
            className="btn-landing btn-landing-dark"
            style={{}}
          >
            <i className="fas fa-arrow-down" />{" "}
            {t("landing.problem.button_solution")}
          </a>
        </div>
      </div>
    </section>
  );
}

function EcosystemSection({ t, i18n }) {
  const ECO_CARDS = [
    {
      num: "01",
      icon: "fas fa-id-badge",
      title: t("landing.eco.c1.title"),
      desc: t("landing.eco.c1.desc"),
      tags: ["VNeID", "Liveness", "OCR"],
      video: "https://www.youtube.com/embed/WV9tCWXzyLQ",
    },
    {
      num: "02",
      icon: "fas fa-pen-nib",
      title: t("landing.eco.c2.title"),
      desc: t("landing.eco.c2.desc"),
      tags: ["Remote Sign", "OTP", "Multi-device"],
      video: "https://www.youtube.com/embed/A5Bd5vR8pn4",
    },
    {
      num: "03",
      icon: "fas fa-file-signature",
      title: t("landing.eco.c3.title"),
      desc: t("landing.eco.c3.desc"),
      tags: ["PAdES", "XAdES", t("landing.eco.c3.n3")],
      video: "https://www.youtube.com/embed/4XzNzKnYhWI",
    },
    {
      num: "04",
      icon: "fas fa-stamp",
      title: t("landing.eco.c4.title"),
      desc: t("landing.eco.c4.desc"),
      tags: ["Batch Seal", "Auto", "API"],
      video: "https://www.youtube.com/embed/IJ1xGJ_8V6U",
    },
    {
      num: "05",
      icon: "fas fa-code",
      title: t("landing.eco.c5.title"),
      desc: t("landing.eco.c5.desc"),
      tags: ["REST API", "SDK", "Webhook"],
      video: "https://www.youtube.com/embed/vcTbwK_6Bus",
    },
    {
      num: "06",
      icon: "fas fa-archive",
      title: t("landing.eco.c6.title"),
      desc: t("landing.eco.c6.desc"),
      tags: ["Audit Trail", "Search", "Export"],
      video: "https://www.youtube.com/embed/vcTbwK_6Bus",
    },
  ];
  return (
    <section id="ecosystem" className="section-pad">
      <div className="gp-container">
        <div className="reveal">
          <span className="tag">{t("landing.eco.bio")}</span>
          <h2 className="section-title" style={{ marginTop: 0 }}>
            {t("landing.eco.title")}
          </h2>
          <p className="section-sub">{t("landing.eco.desc")}</p>
        </div>
        <div className="eco-grid">
          {ECO_CARDS.map((c, i) => (
            <div key={i} className="eco-card reveal">
              <span className="eco-num">{c.num}</span>
              <div className="eco-header">
                <div className="eco-icon">
                  <i className={c.icon} />
                </div>
                <h3>{c.title}</h3>
              </div>
              <p>{c.desc}</p>
              <div className="eco-tags">
                {c.tags.map((t) => (
                  <span key={t} className="eco-tag">
                    {t}
                  </span>
                ))}
              </div>
              <div className="eco-video">
                <iframe
                  src={c.video}
                  title={c.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  referrerpolicy="strict-origin-when-cross-origin"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function ValueSection({ t, i18n }) {
  const VALUE_CARDS = [
    {
      icon: "fas fa-tachometer-alt",
      title: t("landing.value.c1.title"),
      desc: t("landing.value.c1.desc"),
    },
    {
      icon: "fas fa-balance-scale",
      title: t("landing.value.c2.title"),
      desc: t("landing.value.c2.desc"),
    },
    {
      icon: "fas fa-expand-arrows-alt",
      title: t("landing.value.c3.title"),
      desc: t("landing.value.c3.desc"),
    },
    {
      icon: "fas fa-piggy-bank",
      title: t("landing.value.c4.title"),
      desc: t("landing.value.c4.desc"),
    },
    {
      icon: "fas fa-smile",
      title: t("landing.value.c5.title"),
      desc: t("landing.value.c5.desc"),
    },
  ];
  return (
    <section id="value" className="section-pad">
      <div className="gp-container">
        <div className="reveal">
          <span className="tag">{t("landing.value.benefit")}</span>
          <h2 className="section-title" style={{ marginTop: 0 }}>
            {t("landing.value.title")}
          </h2>
          <p className="section-sub">{t("landing.value.desc")}</p>
        </div>
        <div className="value-grid">
          {VALUE_CARDS.map((v, i) => (
            <div
              key={i}
              className="value-card reveal"
              style={{ minHeight: "287px" }}
            >
              <div className="value-card-icon">
                <i className={v.icon} />
              </div>
              <h3>{v.title}</h3>
              <p>{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function ComplianceSection({ t, i18n }) {
  const COMPLIANCE_ROWS = [
    {
      law: t("landing.compliance.table.body.r1.law"),
      scope: t("landing.compliance.table.body.r1.scope"),
      status: t("landing.compliance.table.body.r1.status"),
      benefit: t("landing.compliance.table.body.r1.benefit"),
    },
    {
      law: t("landing.compliance.table.body.r2.law"),
      scope: t("landing.compliance.table.body.r2.scope"),
      status: t("landing.compliance.table.body.r2.status"),
      benefit: t("landing.compliance.table.body.r2.benefit"),
    },

    {
      law: t("landing.compliance.table.body.r3.law"),
      scope: t("landing.compliance.table.body.r3.scope"),
      status: t("landing.compliance.table.body.r3.status"),
      benefit: t("landing.compliance.table.body.r3.benefit"),
    },
    {
      law: t("landing.compliance.table.body.r4.law"),
      scope: t("landing.compliance.table.body.r4.scope"),
      status: t("landing.compliance.table.body.r4.status"),
      benefit: t("landing.compliance.table.body.r4.benefit"),
    },
    {
      law: t("landing.compliance.table.body.r5.law"),
      scope: t("landing.compliance.table.body.r5.scope"),
      status: t("landing.compliance.table.body.r5.status"),
      benefit: t("landing.compliance.table.body.r5.benefit"),
    },
    {
      law: t("landing.compliance.table.body.r6.law"),
      scope: t("landing.compliance.table.body.r6.scope"),
      status: t("landing.compliance.table.body.r6.status"),
      benefit: t("landing.compliance.table.body.r6.benefit"),
    },
    {
      law: t("landing.compliance.table.body.r7.law"),
      scope: t("landing.compliance.table.body.r7.scope"),
      status: t("landing.compliance.table.body.r7.status"),
      benefit: t("landing.compliance.table.body.r7.benefit"),
    },
    {
      law: t("landing.compliance.table.body.r8.law"),
      scope: t("landing.compliance.table.body.r8.scope"),
      status: t("landing.compliance.table.body.r8.status"),
      benefit: t("landing.compliance.table.body.r8.benefit"),
    },
  ];
  return (
    <section id="compliance" className="section-pad">
      <div className="gp-container">
        <div className="reveal">
          <span className="tag">{t("landing.compliance.compliance")}</span>
          <h2 className="section-title" style={{ marginTop: 0 }}>
            {t("landing.compliance.title")}
          </h2>
          <p className="section-sub">{t("landing.compliance.desc")}</p>
        </div>
        <div className="compliance-table-wrapper reveal">
          <table className="compliance-table">
            <thead>
              <tr>
                <th>{t("landing.compliance.table.head.h1")}</th>
                <th>{t("landing.compliance.table.head.h2")}</th>
                <th>{t("landing.compliance.table.head.h3")}</th>
                <th>{t("landing.compliance.table.head.h4")}</th>
              </tr>
            </thead>
            <tbody>
              {COMPLIANCE_ROWS.map((r, i) => (
                <tr key={i}>
                  <td>{r.law}</td>
                  <td>{r.scope}</td>
                  <td>
                    <span className="check-icon">
                      <i className="fas fa-check" />
                    </span>{" "}
                    {r.status}
                  </td>
                  <td>{r.benefit}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}

function ComparisonSection({ t, i18n }) {
  const oldItems = [
    t("landing.comparison.old1"),
    t("landing.comparison.old2"),
    t("landing.comparison.old3"),
    t("landing.comparison.old4"),
    t("landing.comparison.old5"),
    t("landing.comparison.old6"),
  ];
  const newItems = [
    t("landing.comparison.new1"),
    t("landing.comparison.new2"),
    t("landing.comparison.new3"),
    t("landing.comparison.new4"),
    t("landing.comparison.new5"),
    t("landing.comparison.new6"),
  ];
  return (
    <section id="comparison" className="section-pad">
      <div className="gp-container">
        <div className="reveal">
          <span className="tag">{t("landing.comparison.tag")}</span>
          <h2 className="section-title" style={{ marginTop: 0 }}>
            {t("landing.comparison.title")}
          </h2>
          <p className="section-sub">{t("landing.comparison.desc")}</p>
        </div>
        <div className="compare-wrapper reveal">
          <div className="compare-col old">
            <div className="compare-header">
              <i className="fas fa-times-circle" />{" "}
              {t("landing.comparison.old")}
            </div>
            <div className="compare-items">
              {oldItems.map((t, i) => (
                <div key={i} className="compare-item">
                  <i className="fas fa-times compare-icon" />
                  <span>{t}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="compare-col new">
            <div className="compare-header">
              <i className="fas fa-check-circle" />{" "}
              {t("landing.comparison.new")}
            </div>
            <div className="compare-items">
              {newItems.map((t, i) => (
                <div key={i} className="compare-item">
                  <i className="fas fa-check compare-icon" />
                  <span>{t}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function SocialSection({ t, i18n }) {
  const METRICS = [
    {
      target: 500,
      suffix: "+",
      label: t("landing.social.enterprise"),
      decimal: false,
    },
    {
      target: 10,
      suffix: "M+",
      label: t("landing.social.transaction"),
      decimal: false,
    },
    {
      target: 99.9,
      suffix: "%",
      label: t("landing.social.uptime"),
      decimal: true,
    },
    {
      target: 3,
      suffix: "s",
      label: t("landing.social.real_time"),
      decimal: false,
    },
  ];
  const [counts, setCounts] = useState(METRICS.map(() => 0));
  const started = useRef(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const DURATION = 3000;
          const startTime = performance.now();
          const step = (ts) => {
            const elapsed = ts - startTime;
            const progress = Math.min(elapsed / DURATION, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            setCounts(METRICS.map((m) => eased * m.target));
            if (progress < 1) requestAnimationFrame(step);
            else setCounts(METRICS.map((m) => m.target));
          };
          requestAnimationFrame(step);
          obs.unobserve(el);
        }
      },
      { threshold: 0.3 },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const CLIENTS = [
    t("landing.social.enterprise"),
    t("landing.social.insurance"),
    t("landing.social.construction"),
    t("landing.social.Fintech"),
    t("landing.social.logistics"),
    t("landing.social.edu"),
    t("landing.social.health"),
    t("landing.social.build"),
    t("landing.social.e_govornment"),
  ];
  return (
    <section id="social" className="section-pad">
      <div className="gp-container">
        <div className="reveal" style={{ textAlign: "center" }}>
          <span className="tag">{t("landing.social.tag")}</span>
          <h2 className="section-title" style={{ marginTop: 0 }}>
            {t("landing.social.title")}
          </h2>
          <p className="section-sub" style={{ margin: "0 auto" }}>
            {t("landing.social.desc")}
            <br />
            {t("landing.social.desc2")}
          </p>
        </div>
        <div className="metrics-row reveal" ref={sectionRef}>
          {METRICS.map((m, i) => (
            <div key={i} className="metric">
              <div className="metric-num">
                <span>
                  {m.decimal ? counts[i].toFixed(1) : Math.floor(counts[i])}
                </span>
                <span>{m.suffix}</span>
              </div>
              <div className="metric-label">{m.label}</div>
            </div>
          ))}
        </div>
        <div className="clients-row reveal">
          {CLIENTS.map((c, i) => (
            <div key={i} className="client-chip">
              {c}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function SecuritySection({ t, i18n }) {
  const SECURITY_CARDS = [
    {
      icon: "fas fa-lock",
      title: t("landing.security.c1.title"),
      desc: t("landing.security.c1.desc"),
    },
    {
      icon: "fas fa-user-shield",
      title: t("landing.security.c2.title"),
      desc: t("landing.security.c2.desc"),
    },
    {
      icon: "fas fa-server",
      title: t("landing.security.c3.title"),
      desc: t("landing.security.c3.desc"),
    },
    {
      icon: "fas fa-history",
      title: t("landing.security.c4.title"),
      desc: t("landing.security.c4.desc"),
    },
    {
      icon: "fas fa-shield-virus",
      title: t("landing.security.c5.title"),
      desc: t("landing.security.c5.desc"),
    },
    {
      icon: "fas fa-database",
      title: t("landing.security.c6.title"),
      desc: t("landing.security.c6.desc"),
    },
  ];
  return (
    <section id="security" className="section-pad">
      <div className="gp-container">
        <div className="reveal">
          <span className="tag">{t("landing.security.tag")}</span>
          <h2 className="section-title" style={{ marginTop: 0 }}>
            {t("landing.security.title")}
          </h2>
          <p className="section-sub">{t("landing.security.desc")}</p>
        </div>
        <div className="security-grid">
          {SECURITY_CARDS.map((c, i) => (
            <div key={i} className="security-eco-card eco-card reveal">
              <div className="eco-header">
                <div className="eco-icon">
                  <i className={c.icon} />
                </div>
                <h3 style={{ color: "var(--primary)" }}>{c.title}</h3>
              </div>
              <p style={{ color: "var(--text-muted)" }}>{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function WorkflowSection({ t, i18n }) {
  const WORKFLOW_CARDS = [
    {
      num: "01",
      icon: "fas fa-file-signature",
      title: t("landing.workflow.c1.title"),
      items: [t("landing.workflow.c1.desc"), t("landing.workflow.c1.desc2")],
    },
    {
      num: "02",
      icon: "fas fa-mobile-alt",
      title: t("landing.workflow.c2.title"),
      items: [t("landing.workflow.c2.desc"), t("landing.workflow.c2.desc2")],
    },
    {
      num: "03",
      icon: "fas fa-project-diagram",
      title: t("landing.workflow.c3.title"),
      items: [t("landing.workflow.c3.desc"), t("landing.workflow.c3.desc2")],
    },
    {
      num: "04",
      icon: "fas fa-shield-alt",
      title: t("landing.workflow.c4.title"),
      items: [t("landing.workflow.c4.desc"), t("landing.workflow.c4.desc2")],
    },
  ];
  return (
    <section id="workflow-ecosystem" className="section-pad">
      <div className="gp-container">
        <div className="reveal" style={{ textAlign: "center" }}>
          <span className="tag">{t("landing.workflow.tag")}</span>
          <h2 className="section-title" style={{ marginTop: 0 }}>
            {t("landing.workflow.title")}
          </h2>
          <p
            className="section-sub"
            style={{ margin: "0 auto 20px", color: "rgba(255,255,255,0.65)" }}
          >
            {t("landing.workflow.desc")}
          </p>
        </div>
        <div className="workflow-grid">
          {WORKFLOW_CARDS.map((c, i) => (
            <div key={i} className="workflow-card reveal">
              <span className="workflow-card-num">{c.num}</span>
              <div className="workflow-header">
                <div className="workflow-card-icon">
                  <i className={c.icon} />
                </div>
                <h3>{c.title}</h3>
              </div>
              <ul>
                {c.items.map((item, j) => (
                  <li key={j}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function FAQSection({ t, i18n }) {
  const FAQ_TABS = [
    { key: "legacy", label: t("landing.faq.c1") },
    { key: "identification", label: t("landing.faq.c2") },
    { key: "datasecurity", label: t("landing.faq.c3") },
    { key: "legalcompliance", label: t("landing.faq.c4") },
  ];
  const FAQ_DATA = {
    legacy: {
      note: t("landing.faq.note1"),
      items: [
        {
          q: t("landing.faq.q1.question"),
          a: t("landing.faq.q1.answer"),
        },
        {
          q: t("landing.faq.q2.question"),
          a: t("landing.faq.q2.answer"),
        },
        {
          q: t("landing.faq.q3.question"),
          a: t("landing.faq.q3.answer"),
        },
        {
          q: t("landing.faq.q4.question"),
          a: t("landing.faq.q4.answer"),
        },
        {
          q: t("landing.faq.q5.question"),
          a: t("landing.faq.q5.answer"),
        },
        {
          q: t("landing.faq.q6.question"),
          a: t("landing.faq.q6.answer"),
        },
      ],
    },
    identification: {
      note: t("landing.faq.note2"),
      items: [
        {
          q: t("landing.faq.q7.question"),
          a: t("landing.faq.q7.answer"),
        },
        {
          q: t("landing.faq.q8.question"),
          a: t("landing.faq.q8.answer"),
        },
        {
          q: t("landing.faq.q9.question"),
          a: t("landing.faq.q9.answer"),
        },
        {
          q: t("landing.faq.q10.question"),
          a: t("landing.faq.q10.answer"),
        },
        {
          q: t("landing.faq.q11.question"),
          a: t("landing.faq.q11.answer"),
        },
        {
          q: t("landing.faq.q12.question"),
          a: t("landing.faq.q12.answer"),
        },
      ],
    },
    datasecurity: {
      note: t("landing.faq.note3"),
      items: [
        {
          q: t("landing.faq.q13.question"),
          a: t("landing.faq.q13.answer"),
        },
        {
          q: t("landing.faq.q14.question"),
          a: t("landing.faq.q14.answer"),
        },
        {
          q: t("landing.faq.q15.question"),
          a: t("landing.faq.q15.answer"),
        },
        {
          q: t("landing.faq.q16.question"),
          a: t("landing.faq.q16.answer"),
        },
        {
          q: t("landing.faq.q17.question"),
          a: t("landing.faq.q17.answer"),
        },
      ],
    },
    legalcompliance: {
      note: t("landing.faq.note4"),
      items: [
      {
          q: t("landing.faq.q18.question"),
          a: t("landing.faq.q18.answer"),
        },
        {
          q: t("landing.faq.q19.question"),
          a: t("landing.faq.q19.answer"),
        },
        {
          q: t("landing.faq.q20.question"),
          a: t("landing.faq.q20.answer"),
        
        },
        {
          q: t("landing.faq.q21.question"),
          a: t("landing.faq.q21.answer"),
        },
        {
          q: t("landing.faq.q22.question"),
          a: t("landing.faq.q22.answer"),
        },
        {
          q: t("landing.faq.q23.question"),
          a: t("landing.faq.q23.answer"),
        },
        {
          q: t("landing.faq.q24.question"),
          a: t("landing.faq.q24.answer"),
        },
        {
          q: t("landing.faq.q25.question"),
          a: t("landing.faq.q25.answer"),
        },
        {
          q: t("landing.faq.q26.question"),
          a: t("landing.faq.q26.answer"),
        },
        {
          q: t("landing.faq.q27.question"),
          a: t("landing.faq.q27.answer"),
        },
        {
          q: t("landing.faq.q28.question"),
          a: t("landing.faq.q28.answer"),
        },
        {
          q: t("landing.faq.q29.question"),
          a: t("landing.faq.q29.answer"),
        },
        {
          q: t("landing.faq.q30.question"),
          a: t("landing.faq.q30.answer"),
        },
        {
          q: t("landing.faq.q31.question"),
          a: t("landing.faq.q31.answer"),
        },
        {
          q: t("landing.faq.q32.question"),
          a: t("landing.faq.q32.answer"),
        },
        {
          q: t("landing.faq.q33.question"),
          a: t("landing.faq.q33.answer"),
        },
        {
          q: t("landing.faq.q34.question"),
          a: t("landing.faq.q34.answer"),
        },
        {
          q: t("landing.faq.q35.question"),
          a: t("landing.faq.q35.answer"),
        },
        {
          q: t("landing.faq.q36.question"),
          a: t("landing.faq.q36.answer"),
        },
        {
          q: t("landing.faq.q37.question"),
          a: t("landing.faq.q37.answer"),
        },
        {
          q: t("landing.faq.q38.question"),
          a: t("landing.faq.q38.answer"),
        },
        {
          q: t("landing.faq.q39.question"),
          a: t("landing.faq.q39.answer"),
        },
        {
          q: t("landing.faq.q40.question"),
          a: t("landing.faq.q40.answer"),
        },
      ],
    },
  };
  const [activeTab, setActiveTab] = useState("legacy");
  const [openIdx, setOpenIdx] = useState(null);

  const toggleItem = (idx) => setOpenIdx((prev) => (prev === idx ? null : idx));

  const group = FAQ_DATA[activeTab];

  return (
    <section id="faq" className="section-pad">
      <div className="gp-container">
        <div className="reveal">
          <span className="tag">{t("landing.faq.tag")}</span>
          <h2 className="section-title" style={{ marginTop: 0 }}>
            {t("landing.faq.title")}
          </h2>
          <p className="section-sub">{t("landing.faq.desc")}</p>
        </div>
        <div className="faq-tabs">
          {FAQ_TABS.map((t) => (
            <button
              key={t.key}
              className={`faq-tab${activeTab === t.key ? " active" : ""}`}
              onClick={() => {
                setActiveTab(t.key);
                setOpenIdx(null);
              }}
            >
              {t.label}
            </button>
          ))}
        </div>
        <p className="faq-group-note">{group.note}</p>
        {group.items.map((item, i) => (
          <div key={i} className={`faq-item${openIdx === i ? " open" : ""}`}>
            <div className="faq-q" onClick={() => toggleItem(i)}>
              {item.q}
              <i className="fas fa-chevron-down faq-chevron" />
            </div>
            <div
              className="faq-a"
              dangerouslySetInnerHTML={{ __html: item.a }}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
function CTASection({ t, i18n, onOpenModal }) {
  return (
    <section id="cta-final">
      <div className="gp-container" style={{ position: "relative", zIndex: 2 }}>
        <div className="reveal" style={{ textAlign: "center" }}>
          <span className="tag" style={{ background: "rgba(35,156,186,0.2)" }}>
            {t("landing.cta.tag")}
          </span>
          <h2 className="section-title" style={{ marginTop: 0 }}>
            {t("landing.cta.title")}
            <br />
            {t("landing.cta.title2")}
          </h2>
          <p className="cta-accent-line" style={{ fontStyle: "italic" }}>
            {t("landing.cta.desc")}
          </p>
          <div
            style={{
              display: "flex",
              gap: 16,
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <button
              onClick={onOpenModal}
              className="btn-landing btn-landing-primary-landing"
              style={{ fontSize: 16, padding: "16px 40px" }}
            >
              <i className="fas fa-calendar-check" />{" "}
              {t("landing.cta.button_demo")}
            </button>
            <a
              href="tel:19006884"
              className="btn-landing btn-landing-outline btn-phone-shake"
              style={{
                fontSize: 16,
                padding: "16px 40px",
                textDecoration: "none",
                color: "#ffffff",
              }}
            >
              <i className="fas fa-phone" /> {t("landing.cta.button_contact")}
            </a>
          </div>
          <p
            style={{
              marginTop: 24,
              fontSize: 13,
              color: "rgba(255,255,255,0.4)",
            }}
          >
            {t("landing.cta.note")}
          </p>
        </div>
      </div>
    </section>
  );
}
function Footer({ t, i18n }) {
  return (
    <footer>
      <div className="gp-container">
        <div className="footer-inner">
          <div className="footer-brand">
            <img
              src={Logo}
              alt="GoPaperless Logo"
              style={{
                height: 44,
                width: "auto",
                objectFit: "contain",
                marginBottom: 4,
              }}
            />
            <p>{t("landing.footer.title")}</p>
            <div className="footer-socials">
              {[
                ["fab fa-linkedin-in", "#"],
                ["fab fa-facebook-f", "#"],
                ["fab fa-youtube", "#"],
              ].map(([icon, href], i) => (
                <a key={i} href={href} className="footer-social">
                  <i className={icon} />
                </a>
              ))}
            </div>
          </div>
          <div className="footer-col">
            <h5>{t("landing.footer.c1.title")}</h5>
            {[
              [t("landing.footer.c1.r1"), "#ecosystem"],
              [t("landing.footer.c1.r2"), "#ecosystem"],
              [t("landing.footer.c1.r3"), "#ecosystem"],
              [t("landing.footer.c1.r4"), "#ecosystem"],
              [t("landing.footer.c1.r5"), "#ecosystem"],
            ].map(([l, h]) => (
              <a key={l} href={h}>
                {l}
              </a>
            ))}
          </div>
          <div className="footer-col">
            <h5>{t("landing.footer.c2.title")}</h5>
            <a href="/">{t("landing.footer.c2.r1")}</a>
            <a href="#cta-final">{t("landing.footer.c2.r2")}</a>
          </div>
          {/* <div className="footer-col">
            <h5>Tài nguyên</h5>
            <a
              href="https://gopaperless.quantera.vn/documentation"
              target="_blank"
              rel="noreferrer"
            >
              Tài liệu hệ thống
            </a>
          </div> */}
        </div>
        <div className="footer-bottom">
          <p>
            © 2026{" "}
            <a
              href="https://quantera.vn/"
              target="_blank"
              rel="noreferrer"
              style={{ backgroundImage: "none" }}
            >
              Quantera
            </a>
            {t("landing.footer.reserve")}
          </p>
          <p style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
            <a
              href={
                localStorage.getItem("i18nextLng") === "en"
                  ? "https://quantera.vn/en/Quantera-privacy-policy-and-handling-of-personal-data.pdf"
                  : "https://quantera.vn/vi/Quantera-privacy-policy-and-handling-of-personal-data.pdf"
              }
              target="_blank"
              rel="noreferrer"
              style={{ backgroundImage: "none" }}
            >
              {t("landing.footer.security")}
            </a>
            <a
              href={
                localStorage.getItem("i18nextLng") === "en"
                  ? "https://quantera.vn/en/Quantera-terms-of-service.pdf"
                  : "https://quantera.vn/vi/Quantera-terms-of-service.pdf"
              }
              target="_blank"
              rel="noreferrer"
              style={{ backgroundImage: "none" }}
            >
              {t("landing.footer.service")}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
function SpinnerLoading() {
  return (
    <div className="spinner-loading">
      <div className="spinner-loading-content">
        <MoonLoader color="#0033AD" />
      </div>
    </div>
  );
}
function DemoModal({open, onClose }) {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    company: "",
    scale: "",
    industry: "",
    tax: "",
    question: "",
  });
  const [msg, setMsg] = useState(null); // { type: 'error'|'success', text }
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const successNotify = () =>
    toast.success(t("success-dialog.message"), {
      position: "bottom-right",
    });

  const failedNotify = () =>
    toast.error(t("error-dialog.message"), {
      position: "bottom-right",
    });
  const [isSubmitting, setIsSubmitting] = useState(false);
  if (!open) return null;

  const update = (field) => (e) =>
    setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async () => {
    const { name, phone, company, scale, industry, question } = form;

    if (!name || !phone || !company || !scale || !industry || !question) {
      setMsg({
        type: "error",
        text: t("landing.modal.error.missing"),
      });
      return;
    }

    setIsSubmitting(true);
    setMsg(null);

    const formData = new FormData();

    // === Mapping với Google Form ===
    formData.append("entry.1771755790", name); // Họ và tên
    formData.append("entry.200867280", phone); // Số điện thoại (Zalo)
    formData.append("entry.2043042922", company); // Tên doanh nghiệp
    formData.append("entry.1956796114", scale); // Quy mô doanh nghiệp
    formData.append("entry.176637705", industry); // Ngành hàng
    formData.append("entry.35472027", form.tax || ""); // Mã số thuế
    formData.append("entry.1063210194", question); // Thắc mắc

    // Sentinel - BẮT BUỘC
    formData.append("entry.1956796114_sentinel", "");

    const googleFormUrl =
      "https://docs.google.com/forms/d/e/1FAIpQLSf_dYPUZGjhAEPnFHbgxIP-AyQT_V4YYMlmYcxpt0M2Ng8-ZQ/formResponse";

    try {
      setIsLoading(true);
      await fetch(googleFormUrl, {
        method: "POST",
        mode: "no-cors", // Bắt buộc
        body: formData,
      });

      successNotify();
      // setMsg({
      //   type: "success",
      //   text: "Cảm ơn bạn! Chúng tôi sẽ liên hệ trong vòng 24 giờ tới.",
      // });

      // Reset form sau khi thành công

      onClose();
      setForm({
        name: "",
        phone: "",
        company: "",
        scale: "",
        industry: "",
        tax: "",
        question: "",
      });
      setMsg(null);
    } catch (error) {
      // Dù vào catch vẫn submit thành công vì no-cors
      setMsg({
        type: "success",
        text: t("error-dialog.message"),
      });

      setTimeout(() => {
        onClose();
        setForm({
          name: "",
          phone: "",
          company: "",
          scale: "",
          industry: "",
          tax: "",
          question: "",
        });
        setMsg(null);
      }, 2000);
    } finally {
      setIsLoading(false);
      setIsSubmitting(false);
    }
  };

  const handleReset = () => {
    setForm({
      name: "",
      phone: "",
      company: "",
      scale: "",
      industry: "",
      tax: "",
      question: "",
    });
    setMsg(null);
  };

  const SCALES = [
    t("landing.modal.below_50"),
    t("landing.modal.from_50_to_200"),
     t("landing.modal.from_200_to_500"),
     t("landing.modal.above_500"),
  ];

  return (
    <>
      <div
        className="demo-modal-backdrop"
        onClick={(e) => {
          if (e.target === e.currentTarget) onClose();
        }}
      >
        <div className="demo-modal">
          <div className="demo-modal-header">
            <span
              className="tag"
              style={{
                background: "rgba(35,156,186,0.15)",
                color: "#3bbdd6",
                marginBottom: 14,
              }}
            >
              {t("landing.modal.tag")}
            </span>
            <h2
              style={{
                fontFamily: "'Montserrat',sans-serif",
                fontSize: 24,
                fontWeight: 800,
                color: "#fff",
                margin: "0 0 6px",
              }}
            >
              {t("landing.modal.title")}
            </h2>
            <p
              style={{
                fontFamily: "'Montserrat',sans-serif",
                fontSize: 14,
                color: "rgba(255,255,255,0.6)",
                margin: 0,
              }}
            >
              {t("landing.modal.desc")}
            </p>
            <button className="demo-modal-close" onClick={onClose}>
              ×
            </button>
          </div>
          <div className="demo-modal-body">
            {msg && (
              <div className={`demo-form-msg ${msg.type}`}>
                <i
                  className={`fas ${msg.type === "error" ? "fa-exclamation-circle" : "fa-check-circle"}`}
                  style={{ marginRight: 7 }}
                />
                {msg.text}
              </div>
            )}

            <div className="form-group">
              <label className="form-label">
                {t("landing.modal.name")} <span style={{ color: "#e74c3c" }}>*</span>
              </label>
              <input
                className="form-input"
                type="text"
                placeholder={t("landing.modal.placeholder_name")}
                value={form.name}
                onChange={update("name")}
              />
            </div>
            <div className="form-group">
              <label className="form-label">
                {t("landing.modal.phone")} <span style={{ color: "#e74c3c" }}>*</span>
              </label>
              <input
                className="form-input"
                type="tel"
                placeholder={t("landing.modal.placeholder_phone")}
                value={form.phone}
                onChange={update("phone")}
              />
            </div>
            <div className="form-group">
              <label className="form-label">
                {t("landing.modal.company")} <span style={{ color: "#e74c3c" }}>*</span>
              </label>
              <input
                className="form-input"
                type="text"
                placeholder={t("landing.modal.placeholder_company")}
                value={form.company}
                onChange={update("company")}
              />
            </div>
            <div className="form-group">
              <label className="form-label">
                {t("landing.modal.size")} <span style={{ color: "#e74c3c" }}>*</span>
              </label>
              <div className="radio-group">
                {SCALES.map((s) => (
                  <label
                    key={s}
                    className={`radio-label${form.scale === s ? " checked" : ""}`}
                  >
                    <input
                      type="radio"
                      name="df_scale"
                      value={s}
                      checked={form.scale === s}
                      onChange={update("scale")}
                      style={{ accentColor: "#239CBA", margin: 0 }}
                    />{" "}
                    {s}
                  </label>
                ))}
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">
                {t("landing.modal.type_company")} <span style={{ color: "#e74c3c" }}>*</span>
              </label>
              <input
                className="form-input"
                type="text"
                placeholder={t("landing.modal.placeholder_type_company")}
                value={form.industry}
                onChange={update("industry")}
              />
            </div>
            <div className="form-group">
              <label className="form-label">
                {t("landing.modal.tax_code")}
              </label>
              <input
                className="form-input"
                type="text"
                placeholder="0123456789"
                value={form.tax}
                onChange={update("tax")}
              />
            </div>
            <div className="form-group" style={{ marginBottom: 28 }}>
              <label className="form-label">
               {t("landing.modal.issue")} {" "}
                <span style={{ color: "#e74c3c" }}>*</span>
              </label>
              <textarea
                className="form-textarea"
                rows={4}
                placeholder={t("landing.modal.placeholder_issue")}
                value={form.question}
                onChange={update("question")}
              />
            </div>
            <div className="form-actions">
              <button className="form-submit" onClick={handleSubmit}>
                <i className="fas fa-paper-plane" /> {t("landing.modal.button_send")}
              </button>
              <button className="form-reset" onClick={handleReset}>
                <i className="fas fa-redo" /> {t("landing.modal.button_reset")}
              </button>
            </div>
            <p
              style={{
                fontFamily: "'Montserrat',sans-serif",
                fontSize: 12,
                color: "#b0bec5",
                marginTop: 16,
                textAlign: "center",
              }}
            >
              <i className="fas fa-lock" style={{ marginRight: 5 }} />
             {t("landing.modal.note")}
            </p>
          </div>
        </div>
      </div>
      {isLoading && <SpinnerLoading />}
    </>
  );
}

/* ─── MAIN COMPONENT ─── */
export default function Landing() {
  const { t, i18n } = useTranslation();
  const language = useSelector(selectLanguage);
  useEffect(() => {
    document.title = t("landing.title");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);
  const [modalOpen, setModalOpen] = useState(false);
  useReveal();

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: GLOBAL_CSS }} />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css"
      />
      <Navbar t={t} i18n={i18n} onOpenModal={() => setModalOpen(true)} />
      <HeroSlider t={t} i18n={i18n} onOpenModal={() => setModalOpen(true)} />
      <VideoSection t={t} i18n={i18n} />
      <TrustSection t={t} i18n={i18n} />
      <ProblemSection
        t={t}
        i18n={i18n}
        onOpenModal={() => setModalOpen(true)}
      />
      <EcosystemSection t={t} i18n={i18n} />
      <ValueSection t={t} i18n={i18n} />
      <ComplianceSection t={t} i18n={i18n} />
      <ComparisonSection t={t} i18n={i18n} />
      <SocialSection t={t} i18n={i18n} />
      <SecuritySection t={t} i18n={i18n} />
      <WorkflowSection t={t} i18n={i18n} />
      <FAQSection t={t} i18n={i18n} />
      <CTASection t={t} i18n={i18n} onOpenModal={() => setModalOpen(true)} />
      <Footer t={t} i18n={i18n} />
      <DemoModal
        t={t}
        i18n={i18n}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      />
      <ToastContainer t={t} i18n={i18n} />
    </>
  );
}
